


import { CountryVM } from './CountryVM';
import { Gender } from './Gender';
import { NationalityVM } from './NationalityVM';
export class CounsellorRegisterVM {

  organisationJoiningCode?: string;

  email?: string;

  password?: string;

  addressLine1?: string;

  addressLine2?: string;

  city?: string;

  country?: CountryVM;

  state?: string;

  dateOfBirth?: string;

  age?: number;

  displayName?: string;

  firstname?: string;

  gender?: Gender;

  hasProfileImage?: boolean;

  lastname?: string;

  mobile?: string;

  postcode?: string;

  nationality?: NationalityVM;

  timeZone?: string;

  qualification?: string;

  experience?: number;

}
